import { FC, ReactNode, useEffect, useState } from 'react';

import { LDProvider } from 'launchdarkly-react-client-sdk';
import { LDContext } from 'launchdarkly-js-client-sdk';

import { useKeycloakAuth } from '@tsl-frontend/tsl-keycloak-auth';

import { environment } from '@environments/environment';

interface LaunchDarklyProviderProps {
    children?: ReactNode;
}

const clientSideID = environment.launchDarklyKey;
export const LaunchDarklyProvider: FC<LaunchDarklyProviderProps> = ({
    children,
}) => {
    const { user } = useKeycloakAuth();

    const [context, setContext] = useState<LDContext>();

    useEffect(() => {
        if (!user) {
            return;
        }

        setContext({
            kind: 'multi',
            organisation: {
                key: user.memberships[0]?.o_urn,
            },
            user: {
                key: user.id,
                membership: user.memberships[0].m_type,
            },
            app: {
                key: 'curriculum-cms',
            },
        });
    }, [user]);

    return (
        <LDProvider
            clientSideID={clientSideID}
            deferInitialization={true}
            context={context}
        >
            {children}
        </LDProvider>
    );
};

export default LaunchDarklyProvider;
